import { lifecycleHooks } from 'aurelia';
import customers from './customers';

@lifecycleHooks()
export class ValidInstanceHook {
  canLoad(viewModel, params, next) {
    const shortName = next.params.customer ?? next.params.shortName;
    if (!shortName) return true;

    const customer = customers[shortName.toLowerCase()];
    if (!customer || !customer.active) return '';

    return true;
  }
}
